export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_unassigned_manage',
  'conversation_team_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const AGENT_CONVERSATION_PERMISSIONS = [
  'conversation_participating_manage',
  'conversation_team_unassigned_manage',
  'conversation_team_manage',
  'conversation_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_unassigned_manage',
  'conversation_team_manage',
];

export const CONVERSATION_PERMISSION_SUPERSEDES = {
  conversation_manage: [
    'conversation_participating_manage',
    'conversation_team_unassigned_manage',
    'conversation_team_manage',
    'conversation_unassigned_manage',
  ],
  conversation_team_manage: ['conversation_team_unassigned_manage'],
};

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONVERSATION_PARTICIPATING_EXCLUSIVE_BLOCKS = [
  'conversation_manage',
  'conversation_team_unassigned_manage',
  'conversation_team_manage',
];

export const CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS =
  'conversation_team_unassigned_manage';

export const CONVERSATION_TEAM_PERMISSIONS = 'conversation_team_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS, 'custom_role'],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      CONVERSATION_TEAM_PERMISSIONS,
      CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS,
    ],
  },
};
